import * as yup from 'yup';

export const schema = () => {
  return yup.object().shape({
    // Aba Solicitante
    owner: yup.string().required('Informe o solicitante'),
    
    // Aba Dados do MDF-e - campos obrigatórios que estão visíveis na tela
    data_inicio_viagem: yup.string().required('Data de início da viagem é obrigatória'),
    uf_carregamento: yup.string().max(2).required('UF de carregamento é obrigatória'),
    codigo_municipio_carregamento: yup.string().required('Código do município de carregamento é obrigatório'),
    nome_municipio_carregamento: yup.string().required('Nome do município de carregamento é obrigatório'),
    uf_descarregamento: yup.string().max(2).required('UF de descarregamento é obrigatória'),
    codigo_municipio_descarregamento: yup.string().required('Código do município de descarregamento é obrigatório'),
    nome_municipio_descarregamento: yup.string().required('Nome do município de descarregamento é obrigatório'),
    
    // Aba Solicitante - pelo menos 1 viagem selecionada
    delivery_viagens: yup.array().min(1, 'Selecione pelo menos 1 viagem'),
    
    // Aba Rodoviário
    rntrc: yup.string().required('RNTRC é obrigatório'),
    
    // Aba Produto Predominante
    cargo_type: yup.string().required('O tipo de carga é obrigatório'),
    descricao_produto: yup.string().required('Descrição do produto é obrigatória'),
    
    // Aba Totais - todos os campos são obrigatórios
    quantidade_cte: yup
      .mixed()
      .test('is-number', 'Quantidade CT-e deve ser um número', (value) => {
        if (value === '' || value === null || value === undefined) {
          return false;
        }
        return !isNaN(value) && !isNaN(parseFloat(value));
      })
      .test('is-required', 'Quantidade CT-e é obrigatória', (value) => {
        return value !== '' && value !== null && value !== undefined;
      })
      .test('is-min', 'Quantidade CT-e deve ser maior ou igual a 0', (value) => {
        if (value === '' || value === null || value === undefined) return true; // Já validado acima
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      })
      .required('Quantidade CT-e é obrigatória'),
    quantidade_nfe: yup
      .mixed()
      .test('is-number', 'Quantidade NFe deve ser um número', (value) => {
        if (value === '' || value === null || value === undefined) {
          return false;
        }
        return !isNaN(value) && !isNaN(parseFloat(value));
      })
      .test('is-required', 'Quantidade NFe é obrigatória', (value) => {
        return value !== '' && value !== null && value !== undefined;
      })
      .test('is-min', 'Quantidade NFe deve ser maior ou igual a 0', (value) => {
        if (value === '' || value === null || value === undefined) return true;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      })
      .required('Quantidade NFe é obrigatória'),
    quantidade_mdfe: yup
      .mixed()
      .test('is-number', 'Quantidade MDF-e deve ser um número', (value) => {
        if (value === '' || value === null || value === undefined) {
          return false;
        }
        return !isNaN(value) && !isNaN(parseFloat(value));
      })
      .test('is-required', 'Quantidade MDF-e é obrigatória', (value) => {
        return value !== '' && value !== null && value !== undefined;
      })
      .test('is-min', 'Quantidade MDF-e deve ser maior ou igual a 0', (value) => {
        if (value === '' || value === null || value === undefined) return true;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      })
      .required('Quantidade MDF-e é obrigatória'),
    valor_carga: yup
      .mixed()
      .test('is-number', 'Valor da carga deve ser um número', (value) => {
        if (value === '' || value === null || value === undefined) {
          return false;
        }
        return !isNaN(value) && !isNaN(parseFloat(value));
      })
      .test('is-required', 'Valor da carga é obrigatório', (value) => {
        return value !== '' && value !== null && value !== undefined;
      })
      .test('is-min', 'Valor da carga deve ser maior ou igual a 0', (value) => {
        if (value === '' || value === null || value === undefined) return true;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      })
      .required('Valor da carga é obrigatório'),
    peso_bruto: yup
      .mixed()
      .test('is-number', 'Peso bruto deve ser um número', (value) => {
        if (value === '' || value === null || value === undefined) {
          return false;
        }
        return !isNaN(value) && !isNaN(parseFloat(value));
      })
      .test('is-required', 'Peso bruto é obrigatório', (value) => {
        return value !== '' && value !== null && value !== undefined;
      })
      .test('is-min', 'Peso bruto deve ser maior ou igual a 0', (value) => {
        if (value === '' || value === null || value === undefined) return true;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      })
      .required('Peso bruto é obrigatório'),
    peso_liquido: yup
      .mixed()
      .test('is-number', 'Peso líquido deve ser um número', (value) => {
        if (value === '' || value === null || value === undefined) {
          return false;
        }
        return !isNaN(value) && !isNaN(parseFloat(value));
      })
      .test('is-required', 'Peso líquido é obrigatório', (value) => {
        return value !== '' && value !== null && value !== undefined;
      })
      .test('is-min', 'Peso líquido deve ser maior ou igual a 0', (value) => {
        if (value === '' || value === null || value === undefined) return true;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      })
      .required('Peso líquido é obrigatório'),
    value: yup
      .mixed()
      .test('is-number', 'Frete Motorista deve ser um número', (value) => {
        if (value === '' || value === null || value === undefined) {
          return false;
        }
        return !isNaN(value) && !isNaN(parseFloat(value));
      })
      .test('is-required', 'Frete Motorista é obrigatório', (value) => {
        return value !== '' && value !== null && value !== undefined;
      })
      .test('is-min', 'Frete Motorista deve ser maior ou igual a 0', (value) => {
        if (value === '' || value === null || value === undefined) return true;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      })
      .required('Frete Motorista é obrigatório'),
    freight_value: yup
      .mixed()
      .test('is-number', 'Frete Embarcador deve ser um número', (value) => {
        if (value === '' || value === null || value === undefined) {
          return false;
        }
        return !isNaN(value) && !isNaN(parseFloat(value));
      })
      .test('is-required', 'Frete Embarcador é obrigatório', (value) => {
        return value !== '' && value !== null && value !== undefined;
      })
      .test('is-min', 'Frete Embarcador deve ser maior ou igual a 0', (value) => {
        if (value === '' || value === null || value === undefined) return true;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      })
      .required('Frete Embarcador é obrigatório'),
    toll_value: yup
      .mixed()
      .test('is-number', 'Valor do Pedágio deve ser um número', (value) => {
        if (value === '' || value === null || value === undefined) {
          return false;
        }
        return !isNaN(value) && !isNaN(parseFloat(value));
      })
      .test('is-required', 'Valor do Pedágio é obrigatório', (value) => {
        return value !== '' && value !== null && value !== undefined;
      })
      .test('is-min', 'Valor do Pedágio deve ser maior ou igual a 0', (value) => {
        if (value === '' || value === null || value === undefined) return true;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      })
      .required('Valor do Pedágio é obrigatório'),

    // Validações condicionais
    private_trucker_cpf: yup.string().when('type_convocation', {
      is: (value) => value === 'private',
      then: yup
        .string()
        .required('Informar o motorista caso a carga seja privada'),
    }),

    insurance_value: yup.string().when('type_insurance', {
      is: (value) => value === 'carga' || value === 'cargaroubo',
      then: yup
        .string()
        .required(
          'Verifique se o endereço de coleta e entrega foram informados!'
        ),
    }),
  });
};
